export { default } from './ConditionObservationObservedBy';
